/*
 * @LastEditors: Jacky
 * @LastEditTime: 2023-04-06 16:20:31
 * @FilePath: /mojito-xy-interface/src/components/Container.tsx
 * Copyright (c) 2023 by Jacky, All Rights Reserved.
 */
import styled from "styled-components";

const SwapBg = require("../assets/images/trade-bg.png");

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;

  width: 100%;
  padding: 16px;

  background: url(${SwapBg}) top center no-repeat, #fff;
  background-size: cover;
  min-height: calc(100vh - 60px);

  @media screen and (min-width: 350px) {
    background-size: 100% 100%;
  }

  @media screen and (min-width: 768px) {
    background-size: cover;
  }
`;

export default Container;
